<script setup lang="ts">
import Header from '@/components/layout/Header.vue';
import Switchbar from '@/components/layout/Switchbar.vue';
import HomeRouteTabs from '@/views/home/components/HomeRouteTabs.vue';

interface Props {
  focusedMode?: boolean;
  centered?: boolean;
  home?: boolean;
}

withDefaults(defineProps<Props>(), {
  focusedMode: false
});
</script>

<template>
  <div class="main-layout">
    <Switchbar />
    <div
      class="main-wrapper"
      :class="{ focused: focusedMode }"
    >
      <Header />
      <HomeRouteTabs v-if="home" />
      <main :class="{ centered: centered }">
        <slot />
      </main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-layout {
  display: flex;
}

.main-wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: calc(100vw - 95px);

  &.focused {
    background: var(--white);

    main {
      padding: 0;
    }
  }

  .centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

main {
  padding: 25px 0;
  flex-grow: 1;
  overflow-y: auto;
  max-height: calc(100dvh - 60px);
}
</style>
